var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"type":_vm.statusIcon.type,"label":_vm.statusIcon.label,"position":"is-right"}},[_c('b-icon',{staticClass:"has-cursor-help",attrs:{"icon":_vm.statusIcon.icon,"type":_vm.statusIcon.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }